// track:charter-owner-only (spec #66091) — what every member may see of the
// Charter (version and role cards) and whether the caller is the platform
// owner. The server decides; the browser holds no owner id.
import { getAuthHeader } from "./auth";

export interface CharterRoleCardsResponse {
  version: number | null;
  cards: { role: string; text: string }[];
  isPlatformOwner: boolean;
}

export async function fetchCharterRoleCards(workspaceId: string): Promise<CharterRoleCardsResponse> {
  const res = await fetch("/api/charter/role-cards", { headers: await getAuthHeader(workspaceId) });
  if (!res.ok) throw new Error(`Failed to load role cards (HTTP ${res.status})`);
  const body = await res.json();
  return {
    version: typeof body.version === "number" ? body.version : null,
    cards: Array.isArray(body.cards) ? body.cards : [],
    isPlatformOwner: body.isPlatformOwner === true,
  };
}
